/* eslint-disable */
import { Breadcrumbs, Link, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { isUUID } from '../../utils/string'
import OnlineHelpIcon from '../OnlineHelpIcon'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderRole } from '../../utils/provider'
import '../../globalStyle.scss'

export default function RIBreadcrumbsNav() {
  const location = useLocation()
  const { customerId } = useContext(OrgAppContext)
  const { t } = useTranslation()
  const providerRole = getProviderRole(customerId)

  const pathnames = location.pathname
    .split('/')
    .filter((x) => x)
    .filter((e) => !isUUID(e))

  const breadcrumbNameMap: any = {
    alerts: 'Alerts',
    organizationSetting: 'Organization Setting',
    detectionRules: 'Detection Rules',
    edit: 'Edit',
    indicators: 'Indicators',
    alertDashboard: 'Alert Dashboard',
    investigationDashboard: 'Investigation Dashboard',
    providersResult: t('provider.result', { providerRole }),
    providerInvestigation: t('provider.investigation', { providerRole }),
    provider: providerRole,
    client: 'Client',
    clientsResult: 'Client Result',
    clientInvestigation: 'Client Investigation',
    help: 'Help',
    dashboardHelp: 'Dashboard Help',
    upload: 'Upload',
    eubaRules:'EUBA Rules',
    userManagement:'User Management',
    userPermissionDetail :'User Permission Detail',
    breachManagement:'Breach Management',
    breachManagementDetails:'Breach Management Details',
    password: 'Update Password',
  }

  return (
    <div role='presentation' className='breadCrumbStyle'>
      <Breadcrumbs aria-label='breadcrumb'>
        <Link underline='hover' color='inherit' href='/'>
          Home
        </Link>

        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1
          const to = `/${pathnames.slice(0, index + 1).join('/')}`
          const name = breadcrumbNameMap[value] || value

          if (last) {
            return (
              <Typography color='textPrimary' key={value} sx={{ cursor: 'pointer' }}>
                {name}
              </Typography>
            )
          } else {
            return (
              <Link underline='hover' color='inherit' href={to} key={value}>
                {name}
              </Link>
            )
          }
        })}
      </Breadcrumbs>
      <OnlineHelpIcon />
    </div>
  )
}
